export const DESCRIPTOR_KEY_ARCHIVED_ANTRAG = "ProzessBeendetReadonly";
